/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Allroles1Inputs */

const en_common_allroles1 = /** @type {(inputs: Common_Allroles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Roles`)
};

/**
* | output |
* | --- |
* | "All Roles" |
*
* @param {Common_Allroles1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_allroles1 = /** @type {((inputs?: Common_Allroles1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Allroles1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_allroles1(inputs)
});
export { common_allroles1 as "common_allRoles" }